module.exports = __webpack_public_path__ + "img/hide-projects.0bfba81a.svg";